module.exports = __webpack_public_path__ + "media/win.ace8bf01.mp3";